import { render, staticRenderFns } from "./home-dashboard.html?vue&type=template&id=2f06d946&scoped=true&"
import script from "./home-dashboard.js?vue&type=script&lang=js&"
export * from "./home-dashboard.js?vue&type=script&lang=js&"
import style0 from "./home-dashboard.scss?vue&type=style&index=0&id=2f06d946&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06d946",
  null
  
)

export default component.exports